export const customStyles = {
    rows: {
        style: {
         // backgroundColor: "#D6DFFB"
        }
    },
    header: {
		style: {
			color: '#8492A6',
			fontSize: '10px',
			fontWeight: 600,
		},
	},
    headRow: {
		style: {
			background: '#FAFAFA',
            color: '#8492A6',
            fontWeight: '600',
            fontSize: '1rem'
		},
	},
    cells: {
        style: {
            fontWeight: '400'
        }
    },
    headCells: {
        style: {
            fontSize: '1rem'
        }
    }
}

export const customHeadStyles = {
    headCells: {
        style: {}
    }
}